'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _constants = require('../../constants');
var _formatAddress = require('../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _AboutCompany = require('./AboutCompany.scss');var styles = _interopRequireWildcard(_AboutCompany);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _CompanyGallery = require('../Company/CompanyGallery/CompanyGallery');var _CompanyGallery2 = _interopRequireDefault(_CompanyGallery);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

/* eslint-disable indent */var
AboutCompany = function (_Component) {_inherits(AboutCompany, _Component);function AboutCompany() {var _temp, _this, _ret;_classCallCheck(this, AboutCompany);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderCompanyBranch = function (name, address, isDefaultLang) {var _cx;return (
        _react2.default.createElement('p', { className: (0, _classnames2.default)((_cx = {}, _cx[styles.defaultLang] = isDefaultLang, _cx)), key: (0, _uniqueId2.default)('branch') },
          name || _this.props.translate('filial'), ':\xA0\xA0', address));}, _this.



    renderAddress = function (address) {return _react2.default.createElement('p', null, _this.props.translate('address'), ':\xA0\xA0', address);}, _this.

    renderCompanyBranches = function () {var _this$props =
      _this.props,branches = _this$props.branches,locale = _this$props.locale;

      if (branches && branches.length === 1) {
        var address = (0, _get2.default)(branches, '[0].address') || {};
        var formattedAddress = (0, _formatAddress2.default)(address[locale] || address.en);
        return _this.renderAddress(formattedAddress);
      }

      return branches.map(function (_ref) {var name = _ref.name,address = _ref.address;
        var localizedName = name && (name[locale] || name[_constants.language.default]);
        var isNameAtDefaultLang = name && !name[locale];
        var formattedAddress = (0, _formatAddress2.default)(address[locale] || address.en);
        return _this.renderCompanyBranch(localizedName, formattedAddress, isNameAtDefaultLang);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);}AboutCompany.prototype.

  render = function render() {var _this2 = this,_cx2,_cx3;
    return (
      _react2.default.createElement('div', { className: styles.aboutCompany, ref: function ref(_ref2) {_this2.wrapperRef = _ref2;} },
        _react2.default.createElement('h1', { className: (0, _classnames2.default)((_cx2 = {}, _cx2[styles.defaultLang] = this.props.isTitleAtDefaultLang, _cx2)) }, this.props.title),

        _react2.default.createElement('div', { className: 'company-contacts' },
          _react2.default.createElement('div', { className: 'company-contact-info' },
            _react2.default.createElement('div', { className: 'company-contact-info-section' },
              this.props.companyName &&
              _react2.default.createElement('p', { className: (0, _classnames2.default)((_cx3 = {}, _cx3[styles.defaultLang] = this.props.isNameAtDefaultLang, _cx3)) },
                _react2.default.createElement('i', { className: 'icon icon-office' }),
                _react2.default.createElement('span', null, this.props.companyName)),



              this.props.ownerName &&
              _react2.default.createElement('p', null,
                _react2.default.createElement('i', { className: 'icon icon-user' }),
                _react2.default.createElement('span', null, this.props.ownerName)),



              this.props.phoneNumber &&
              _react2.default.createElement('p', null,
                _react2.default.createElement('i', { className: 'icon icon-phone' }),
                _react2.default.createElement('a', { href: 'tel:' + this.props.phoneNumber, 'data-rel': 'external' }, this.props.phoneNumber))),




            _react2.default.createElement('p', { className: 'blank-line' }),

            _react2.default.createElement('div', null,
              this.props.email &&
              _react2.default.createElement('p', null, this.props.translate('email'), ':',
                _react2.default.createElement('a', { href: 'mailto:' + this.props.email }, this.props.email)),



              this.props.website &&
              _react2.default.createElement('p', null, this.props.translate('website'), ':',
                _react2.default.createElement('a', { href: this.props.website, target: '_blank', rel: 'nofollow noopener noreferrer' },
                  this.props.website && this.props.website.split('//').pop())),




              this.renderCompanyBranches(),

              this.props.address && this.renderAddress(this.props.address),

              this.props.licenseFrom &&
              _react2.default.createElement('p', null, this.props.translate('licenseFrom'), ':\xA0\xA0', this.props.licenseFrom))),





          _react2.default.createElement('div', {
            className: 'company-logo',
            style: {
              backgroundImage: 'url(' + this.props.profileImage + ')' } })),




        this.props.shareRow,

        this.props.description && _react2.default.createElement('hr', null),

        !!this.props.images.length &&
        _react2.default.createElement('div', { className: styles.galleryWrapper },
          _react2.default.createElement(_CompanyGallery2.default, {
            wrapperWidth: this.wrapperRef && this.wrapperRef.offsetWidth,
            images: this.props.images,
            openLightbox: this.props.openLightbox,
            isMobile: this.props.isMobile }))));





  };return AboutCompany;}(_react.Component);exports.default = AboutCompany;


AboutCompany.propTypes = {
  translate: _propTypes2.default.func,
  companyName: _propTypes2.default.string,
  ownerName: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string,
  email: _propTypes2.default.string,
  website: _propTypes2.default.string,
  branches: _propTypes2.default.array,
  licenseFrom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  description: _propTypes2.default.string,
  profileImage: _propTypes2.default.string,
  title: _propTypes2.default.string,
  address: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  isNameAtDefaultLang: _propTypes2.default.bool,
  isTitleAtDefaultLang: _propTypes2.default.bool,
  isDescriptionAtDefaultLang: _propTypes2.default.bool,
  shareRow: _propTypes2.default.element,
  isCommunityMember: _propTypes2.default.bool,
  images: _propTypes2.default.array,
  openLightbox: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutCompany/AboutCompany.js
// module id = 2604
// module chunks = 0